/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TipoGestionale {
    Esolver = 0,
    Spring = 1,
}
